import moment from 'moment';

( function( $ ) {

  let loadPosts = {

    settings: {
      loadMoreButton  : document.getElementById( 'load-more' ),
      body            : document.getElementsByTagName( 'body' )[0],
      maxPages        : loadMoreData['pages'],
      dateFormat      : loadMoreData['date_format']
    },

    init: function() {

      if ( null !== this.settings.loadMoreButton ) {
        this.bindUIActions();
      }

    },

    bindUIActions: () => {

      let s = loadPosts.settings;

      // Start a counter from the next page
      // (we're already on the first page)
      let i = loadMoreData['current_page'];
      i++;

      s.loadMoreButton.addEventListener( 'click', () => {

        if( i <= s.maxPages ) {
          loadPosts.getPosts( i, s );
          i++
        }

      });

    },

    getPosts: ( page ) => {

      let s = loadPosts.settings;
      let maxPages = s.maxPages;

      jQuery.ajax({

        url: '/wp-json/wp/v2/posts',
        dataType: 'json',
        data: { // Match the query that was already run on the page
          'per_page': loadMoreData['per_page'],
          'page': page,
          'orderby': loadMoreData['orderby']
        },

        success: ( data, textStatus, request ) => {

          console.warn( 'Page ' + page + ' successfully loaded'  );

          let posts = [];

          // Remove the button if the response returns no items
          if ( data.length < 1 ) {
            jQuery('#load-more').remove();
          } else {

            jQuery.each( data, function( item, post ){

              // Setup template for the post
              let template = wp.template( 'post-template' );

              // Format some parts of the post data that won't display
              // nicely otherwise
              post.title.rendered = post.title.rendered;
              post.modified       = moment( post.modified ).format( 'DD.MM.YYYY' );
              post.date           = moment( post.date ).format( 'DD.MM.YYYY' );

              // Put the post data into the template!
              let postHTML = template( post );

              // Add the post to the posts array.
              posts.push( postHTML );

            });

            if ( posts.length >= 3 ){
              jQuery( ".posts--main" ).append( posts );
            } else {
              jQuery( ".posts--main" ).append( posts );
            }

          }

          let nextPage = page + 1;
          console.warn( 'Next page is page ' + nextPage + ', total pages to load is ' + maxPages );

          if( nextPage > maxPages ) {
            jQuery('#load-more').remove();
            console.warn( 'No more pages to load' );
          }

        },

        error: ( jqXHR, textStatus, errorThrown ) => {

          let errorStatus = jqXHR.status + ' ' + jqXHR.statusText + '\n';
          let errorMessage = jqXHR.responseJSON.message;

          // Show what the error was
          console.log( errorStatus + errorMessage );

          jQuery('#load-more').html( '... Error Loading Posts' );

        }

      });

    }

  }

  $( document ).ready( function() {

    let loadMorePosts = Object.create( loadPosts );
    loadMorePosts.init();

  });

})( jQuery );